export default {
  data() {
    return {
      visible: false,
      intersectionOptions: {
        threshold: 0.5,
      },
    }
  },
  methods: {
    onWaypoint({ going }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.visible = true
      }
    },
  },
}
